import { EventEmitter, Injectable } from '@angular/core';
import { AuthenticationService } from '../security/services/authentication.service';
import { LocalStoragesService } from './local-storages.service';
// import { DailyReportColControl } from '../payments/models/daily-report';

interface SessionData{
  abnormalIC:string;
  patientHistdata:{patientNo:string};
  /** 醫師PIN */
  doctorPinCode: {Uesr:string,PinCode:string,Cert:string};
  hcaModule:{InitModule:number,InitSession:number};
  AnnAlert:{sec:number,ann:number[]}[]
  ToccAlert:{sec:number,user:number,patient:number}[]
  patientRecvSeqNo: {RegId:number,RecvSeqNo:string};

  /** 此次登入是否寫IC卡 */
  writeCardData: boolean;
  /** 此次登入是否使用電子病歷 */
  useEmr: boolean;
  /** 此次登入使用哪個情境，紀錄ClinicSessionSetting的id ，若0代表 =>沒有自訂情境，也沒有衛星藥局*/
  SituationId?: number;
  /**此次登入是否傳送衛星藥局 改回bool */
  useSatellite: boolean;
  /** 此次登入是否使用巡診 */
  useOutVisit: boolean;
  /** 此次登入是否使監獄 */
  useOutVisitJail?: boolean;
  useDentalOutVisit?: boolean;
  outVisitSessionType?: number | null;
  dentalOutVisitMountainIsland?: boolean;

  loginSituation:{
    Addition:string,
    ClinicId:number,
    DefaultSPTX:string,
    DefaultSpecAreaSV?: string,
    DefaultSupArea?: string,
    Id:number,
    IsAlive:boolean,
    IsEnabled:boolean,
    JailAddressCode:string
    Name:string
    SatellitePhamacyIP:string;
    PolarisHostUrl?:string;
    Type:number
  }
  /** 擴充的收據列印設定 */
  additionPrintSetting?: string;
  //CYY:新增的項目可以打個問號，比較不會有相容性的問題
  emrXmlPath?: string; //↑ 辰: 好的
  /** 牙科 巡診感控SOP 勾選狀態（巡診情境下為 0/1，非巡診情境為 null） */
  dentalOutVisitSop?: number | null;
  /** 檢查那個不能說的東西的Hash */
  HashForCheck?:string;
}


@Injectable({
  providedIn: 'root'
})
/** 登入後記錄一些操作資訊使用，登出後即清除 */
export class SessionService {

  logoutEvent = new EventEmitter<void>();
  sessionData: any = {};
  constructor(private localStorage: LocalStoragesService) {
    this.loadSessionData();
    // 登出時清空 (改由AuthenticationService呼叫)
    // this.auth.logoutEvent.subscribe(() => {
    //   this.logout()
    // })
  }

  public logout(){
    // 登出後要保留的例外
    var keep = {};
    if(this.sessionData[this.KEY_AbnormalIC] == 'G000'){
      keep[this.KEY_AbnormalIC] = 'G000'
    }
    this.sessionData = keep;
    this.saveSessionData();
    this.logoutEvent.emit();
  }
  //#region 異常掛號
  private KEY_AbnormalIC = 'abnormalIC';
  setAbnormalIC(code) {
    this.sessionData[this.KEY_AbnormalIC] = code;
    this.saveSessionData();
  }

  getAbnormalIC() {
    return this.sessionData[this.KEY_AbnormalIC];
  }
  //#endregion

  //#region 藥師選擇
  private KEY_Pharmacy = 'phar';
  setPhar(ph) {
    this.sessionData[this.KEY_Pharmacy] = ph;
    this.saveSessionData();
  }
  getPhar() {
    return this.sessionData[this.KEY_Pharmacy];
  }
  //#endregion

  setData<K extends keyof SessionData>(key: K,value: SessionData[K]) {
    this.sessionData[key] = value;
    this.saveSessionData();
  }

  getData<K extends keyof SessionData>(key:K):SessionData[K] {
    return this.sessionData[key];
  }

  //#region 方法Private
  private loadSessionData() {
    var session = this.localStorage.getItem('SessionData');
    if (session == null) {
      session = {}
      this.localStorage.setItem('SessionData', {});
    };
    this.sessionData = session;
  }

  private saveSessionData() {
    this.localStorage.setItem('SessionData', this.sessionData);
  }
  //#endregion
}
